import {Row} from '../../components/Row';
import React, {memo, ReactNode, useEffect, useRef, useState} from 'react';
import {Container} from '../../components/Container';
import {useDispatch, useSelector} from "react-redux";
import {Column} from "../../components/Column";
import {Widget} from "../../components/Widget";
import iconPlace from '../../assets/images/icons/area/place.png';
import iconRoom from '../../assets/images/icons/area/room.png';
import iconFloor from '../../assets/images/icons/area/room.png';
import {AreaModel} from "../../store/control/state";
import {useLocation} from 'react-router-dom';
import {useParams} from "react-router-dom";
import {Control} from "../../components/ItemList/control";
import {backButtonToggle, groupSettingAction, scenarioSettingAction} from "../../store/ui/actions";
import {Link} from "../../components/Link";
import {useRPC} from "../../hooks/rpc";
import {
    CONTROL_TYPE_ID_CURTAIN,
    CONTROL_TYPE_ID_DIMMER,
    CONTROL_TYPE_ID_LIGHT,
    CURTAIN_VALUE_CLOSE,
    DIMMER_VALUE_OPEN
} from "../../types/control";
import {useDebounce} from "../../hooks/debounce";
import {entityUpdatedAction, setGroupControlsAction} from "../../store/control/actions";
import {delay} from "../../utils/promise";
import {useTimer} from "../../hooks/timer";
import {usePrevious} from "../../hooks/previous";
import {useInterval} from "../../hooks/interval";


export const icons = {
    'place': iconPlace,
    'room': iconRoom,
    'floor': iconFloor
};

const AreaButton = memo(function AreaButton({
                                            area,
                                            children,
                                        }: { area?: AreaModel, children?: ReactNode }) {
    return (
        <Column min={3} max={6}>
            <Widget style={{padding: 0}}>
                <Link icon={icons[area.type]} title={area.name} to={`/area/${area.id}`}>
                    {children}
                </Link>
            </Widget>
        </Column>
    );
});

export const AreaScreen = memo(function AreaScreen() {
    const location = useLocation();
    const dispatch = useDispatch();
    const {id} = useParams();
    let allAreaList = useSelector(state => state.control.areaList);
    const allControlList = useSelector(state => state.control.controlList);
    const parentArea = allAreaList.find((item) => item.id === (id ? id : ''));
    const areaList = allAreaList.filter(item => item.parent_area_id === (id ? id : ''));
    const controlList = allControlList.filter(c => c.area_id === id);
    useEffect(() => {
        if (parentArea) {
            dispatch(backButtonToggle({is_open: true, to: '/area/' + parentArea.parent_area_id}));
            if (controlList && controlList.length > 0) {
                dispatch(groupSettingAction({visible: true}));
                dispatch(scenarioSettingAction({visible: false}));
                dispatch(setGroupControlsAction(controlList));
            } else {
                dispatch(groupSettingAction({visible: false}));
                dispatch(scenarioSettingAction({visible: true}));
            }
        } else {
            dispatch(backButtonToggle({is_open: true, to: '/'}));
            dispatch(groupSettingAction({visible: false}));
            dispatch(scenarioSettingAction({visible: true}));
        }
    }, [location]);

    return (
        <Container>
            <div className="page-wrapper">
                <Row>
                    {
                        areaList && areaList.map((area, index) => (
                                <AreaButton area={area} key={index}/>
                            ),
                        )
                    }
                </Row>
                <Row>
                    {
                        ((controlList && controlList.length > 0) && (areaList && areaList.length > 0)) ?
                            <div className='divider'/> : null
                    }
                    {
                        controlList && controlList.map((item) => (
                            <Control key={`control_${item.id}`}
                                     control={item}/>
                        ))
                    }
                </Row>
            </div>
        </Container>
    );
});
